import { CoreErrorDetails, InvalidEntityErrorDetail } from '../error-handler.backend-types'
import { TFunction } from 'i18next'

export function getInvalidEntityMessage(t: TFunction, details?: CoreErrorDetails<'INVALID_ENTITY'>): string | null {
  if (!details?.entity) {
    return null
  }

  let message = t('pms.core_error.invalid_entity.prefix', { entity: details.entity })

  if (details.errors && details.errors.length > 0) {
    message = message + ': '
    const messageDetails = details.errors.map((e) => getDetail(t, e))
    message = message + messageDetails.join(', ') + '.'
  } else {
    message = message + '.'
  }

  return message
}

function getDetail(t: TFunction, e: InvalidEntityErrorDetail): string {
  switch (e.errorType) {
    case 'MISSING':
      return e.field ? t('pms.core_error.invalid_entity.suffix.missing_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.missing_entity')
    case 'INVALID':
      return e.field ? getInvalidField(t, e.field) : t('pms.core_error.invalid_entity.suffix.invalid_entity')
    case 'DUPLICATED':
      return e.field ? t('pms.core_error.invalid_entity.suffix.duplicated_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.duplicated_entity')
    case 'NON_POSITIVE':
      return e.field ? t('pms.core_error.invalid_entity.suffix.not_positive_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.not_positive_entity')
    case 'CYCLIC_RELATION':
      return e.field ? t('pms.core_error.invalid_entity.suffix.cyclic_relation_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.cyclic_relation_entity')
    case 'CONFLICT':
      return e.field ? t('pms.core_error.invalid_entity.suffix.conflict_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.conflict_entity')
    case 'ALREADY_EXISTS':
      return e.field ? t('pms.core_error.invalid_entity.suffix.already_exisits_field', { field: e.field }) : t('pms.core_error.invalid_entity.suffix.already_exists_entity')
  }
  return checkSwitchExhaustive(e.errorType)
}

function getInvalidField(t: TFunction, field: string) {
  if (field.includes('adults')) {
    return t('pms.core_error.invalid_entity.suffix.invalid_field.occupancy_overflow')
  } else if (field.includes('inventory')) {
    return t('pms.core_error.invalid_entity.suffix.invalid_field.inventory_overflow')
  } else {
    return t('pms.core_error.invalid_entity.suffix.invalid_field', { field: field })
  }
}

function checkSwitchExhaustive(x: never): never {
  throw new Error('Switch not exhaustive')
}
